import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function IncludesSection() {
  return <section className="w-full bg-bg-section py-16 md:py-24 px-4" data-id="element-168">
      <div className="max-w-5xl mx-auto" data-id="element-169">
        <div className="text-center mb-12 md:mb-16" data-id="element-170">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6" data-id="element-171">
            Qué incluye el sistema
          </h2>
          <p className="text-base md:text-xl text-text-secondary leading-relaxed max-w-3xl mx-auto" data-id="element-172">
            EMPRENDE USA EXPRESS es un sistema completo paso a paso que te guía
            desde el registro hasta el dominio total de tu empresa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-173">
          <div className="bg-bg-card p-6 md:p-8 rounded-lg" data-id="element-174">
            <CheckCircleIcon className="w-8 h-8 md:w-10 md:h-10 text-cta mb-3 md:mb-4" data-id="element-175" />
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-176">
              Guía paso a paso completa
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-177">
              Instrucciones detalladas para cada etapa del proceso, desde el
              registro legal hasta el cumplimiento continuo.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg" data-id="element-178">
            <CheckCircleIcon className="w-8 h-8 md:w-10 md:h-10 text-cta mb-3 md:mb-4" data-id="element-179" />
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-180">
              Sistema de 4 pilares
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-181">
              Metodología probada que integra aspectos legales, fiscales,
              financieros y de cumplimiento en un sistema coherente.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg" data-id="element-182">
            <CheckCircleIcon className="w-8 h-8 md:w-10 md:h-10 text-cta mb-3 md:mb-4" data-id="element-183" />
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-184">
              Proceso de registro empresarial
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-185">
              Cómo elegir entre LLC y Corporation, completar el registro ante el
              Secretary of State, y crear tu Operating Agreement.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg" data-id="element-186">
            <CheckCircleIcon className="w-8 h-8 md:w-10 md:h-10 text-cta mb-3 md:mb-4" data-id="element-187" />
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-188">
              Configuración fiscal completa
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-189">
              Proceso completo para obtener tu EIN y configurar correctamente la
              identidad fiscal de tu empresa ante el IRS.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg" data-id="element-190">
            <CheckCircleIcon className="w-8 h-8 md:w-10 md:h-10 text-cta mb-3 md:mb-4" data-id="element-191" />
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-192">
              Infraestructura bancaria
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-193">
              Cómo abrir tu cuenta bancaria empresarial correctamente y separar
              tus finanzas personales de las empresariales.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg" data-id="element-194">
            <CheckCircleIcon className="w-8 h-8 md:w-10 md:h-10 text-cta mb-3 md:mb-4" data-id="element-195" />
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-196">
              Sistema de cumplimiento
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-197">
              El Calendario del Dueño: Annual Reports, obligaciones fiscales,
              supervisión contable y renovaciones empresariales.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg" data-id="element-198">
            <CheckCircleIcon className="w-8 h-8 md:w-10 md:h-10 text-cta mb-3 md:mb-4" data-id="element-199" />
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-200">
              Formato PDF descargable
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-201">
              Acceso inmediato al ebook completo en formato PDF para consultar
              cuando lo necesites.
            </p>
          </div>

          <div className="bg-bg-card p-6 md:p-8 rounded-lg" data-id="element-202">
            <CheckCircleIcon className="w-8 h-8 md:w-10 md:h-10 text-cta mb-3 md:mb-4" data-id="element-203" />
            <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3" data-id="element-204">
              Aplicable a cualquier negocio
            </h3>
            <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-205">
              Funciona para emprendedores, freelancers, consultores, e-commerce,
              negocios digitales y negocios tradicionales.
            </p>
          </div>
        </div>
      </div>
    </section>;
}